<script>
import Home from '../pages/Home.vue'
import Dashboard from '../pages/Dashboard.vue'
import Login from '../components/layout/Login.vue'
import Admin from '../components/layout/Admin.vue'
import Guest from '../components/layout/Guest.vue'
import Initial from '../components/layout/Initial.vue'
import Test from '../components/layout/Test.vue'
import UnderConstruction from '../components/UnderConstruction'
import Booking from '../pages/booking/Booking'
import BookingIndex from '../pages/booking/BookingIndex'
import BookingDetail from '../pages/booking/BookingDetail'
import BookingDeleted from '../pages/booking/BookingDeleted'
import Financial from '../pages/financials/Financial'
import Guesthouses from '../pages/guesthouses/Guesthouses'
import EditGuesthouse from '../pages/guesthouses/EditGuesthouse'
import EditRoom from '../pages/guesthouses/EditRoom'
import User from '../pages/user/User'
import EditUser from '../pages/user/EditUser'
import Price from '../pages/prices/Price'
import Profile from '../pages/profile/Profile'
import News from '../pages/news/News'
import EditNews from '../pages/news/EditNews'
import Coupon from '../pages/coupons/Coupon'
import Statistics from '../pages/statistics/Statistics'
import Settings from '../pages/settings/Settings'
import EmailIndex from '../pages/emails/EmailIndex'
import Transaction from '../pages/financials/Transaction'
import HotelDatePickerTest from '../pages/HotelDatePickerTest'
import VirtualAPI from '../pages/virtualapi/VirtualAPI'
import UserBookings from '../pages/user/UserBookings'
	
//import Newsfeed from '../pages/newsfeed/Newsfeed'

const routes = [
	{ 
		path: '/',
		component: Initial,
		name: 'Initial',
		meta: { layout: Initial, authOnly: true}
	},
	{
		path: '/login',
		component: Login,
		name:'Login',
		meta: { layout: Login, guestOnly: true }
	},
	{ 
		path: '/under-construction',
		component: UnderConstruction,
		name: 'UnderConstruction',
		meta: { layout: Guest, authOnly: true}
	},
	{ 
		path: '/under-construction-admin',
		component: UnderConstruction,
		name: 'UnderConstructionAdmin',
		meta: { layout: Admin, authOnly: true,}
	},
	{ 
		path: '/home',
		component: Home,
		name: 'Home',
		meta: { layout: Guest, authOnly:true, role: 'guest'}
	},
	{ 
		path: '/dashboard',
		component: Dashboard,
		name: 'Dashboard',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/booking',
		component: Booking,
		name: 'Booking',
		meta: { layout: Guest, authOnly: true, role: 'guest' }
	},
	{ 
		path: '/test',
		component: HotelDatePickerTest,
		name: 'HotelDatePickerTest',
		meta: { layout: Test, guestOnly:true }
	},
	{ 
		path: '/guesthouses',
		component: Guesthouses,
		name: 'Guesthouses',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/guesthouses/:id/edit',
		component: EditGuesthouse,
		name: 'EditGuesthouse',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/rooms/:id/edit',
		component: EditRoom,
		name: 'EditRoom',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/base-data/users',
		component: User,
		name: 'User',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/base-data/settings',
		component: Settings,
		name: 'Settings',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/base-data/users/:id/edit',
		component: EditUser,
		name: 'EditUser',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/base-data/users/:id/bookings',
		component: UserBookings,
		name: 'UserBookings',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/prices',
		component: Price,
		name: 'Price',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/bookings',
		component: BookingIndex,
		name: 'BookingIndex',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/bookings/deleted',
		component: BookingDeleted,
		name: 'BookingDeleted',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/bookings/:id',
		component: BookingDetail,
		name: 'BookingDetail',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/news',
		component: News,
		name: 'News',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/news/:id/edit',
		component: EditNews,
		name: 'EditNews',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/financials',
		component: Financial,
		name: 'Financial',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/transactions',
		component: Transaction,
		name: 'Transaction',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/profile',
		component: Profile,
		name: 'Profile',
		meta: { layout: Guest, authOnly: true, role: 'guest' }
	},
	{ 
		path: '/profile-admin',
		component: Profile,
		name: 'Profile',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/coupons',
		component: Coupon,
		name: 'Coupon',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/statistics',
		component: Statistics,
		name: 'Statistics',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/virtual-api',
		component: VirtualAPI,
		name: 'VirtualAPI',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	{ 
		path: '/emails',
		component: EmailIndex,
		name: 'EmailIndex',
		meta: { layout: Admin, authOnly: true, role: 'admin' }
	},
	
]

export default routes;
</script>
